import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import AppContent from 'components/AppContent';
import { Styles, Toolbar, ToolbarGroup, Paper } from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';

let { Spacing } = Styles;

export default class AppPage extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string
  };

  getStyle() {
    let left = 0;
    let right = 0;
    // if (this.context.media == 'desktop') {
    //   left = Spacing.desktopKeylineIncrement*3;
    //   right = Spacing.desktopKeylineIncrement*3;
    // } else if (this.context.media == 'tablet') {
    //   left = Spacing.desktopKeylineIncrement*2;
    //   right = Spacing.desktopKeylineIncrement*2;
    // }
    return {
      position: 'absolute',
      left: left,
      right: right,
      top: 0,
      bottom: 0,
      backgroundColor: this.context.muiTheme.rawTheme.palette.cardColor,
      overflow: 'auto',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    };
  }

  onScrollToBottom() {
    if (this.props.onScrollToBottom) {
      this.props.onScrollToBottom();
    }
  }

  getToolbarStyle() {
    let style = {
      backgroundColor: this.context.muiTheme.rawTheme.palette.primary1Color,
      borderStyle: 'none none solid none',
      borderWidth: '1px',
      borderColor: '#DDD'
    };
    return style;
  }

  render() {
    let { style, header, ...other } = this.props;

    let toolbar = <Toolbar style={this.getToolbarStyle()} />;

    style = Object.assign(this.getStyle(), style);
    return (
      <div
        style={{
          position: 'relative',
          boxSizing: 'border-box',
          height: '100%'
        }}
      >
        {toolbar}
        <Paper zDepth={2} style={this.getStyle()}>
          <ScrollableContainer
            header={header}
            onScrollToBottom={this.onScrollToBottom.bind(this)}
          >
            {this.props.children}
          </ScrollableContainer>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/FullWidthPane.js